<template>
  <div>
    <Loader v-if="isLoading"></Loader>
    <div v-else-if="!isLoading && items.length < 1">
      {{ $t('notifications.noData') }}
    </div>
    <div v-else>
      <table class="table table-sm table-striped table-hover">
        <tr>
          <th style="width: 45%">{{$t('views.excmrelation.list.name')}}</th>
          <th style="width: 30%">{{$t('views.excmrelation.list.dateFrom')}}</th>
          <th>ID</th>
          <th style="width: 25%"> </th>
        </tr>
        <tbody>
        <tr
          v-for="item in items"
          :key="item['@id']">
          <td>
            {{ item['title'] }}
          </td>
          <td>
            {{ item['dateFrom'] }}
          </td>
          <td>
            <router-link v-if="item && item.idCase && !($route.params.id === item.idCase)" :to="{name: 'EXCMCaseShow', params: { id: item.idCase }}">
              {{ getIdLink(item.idCase) }}
            </router-link>
            <div v-else-if="item.idCase">
              {{ getIdLink(item.idCase) }}
            </div>
          </td>
          <td>
            <div v-if="canShowRelation" class="float-right">
              <button class="btn btn-link fa fa-search fa-lg" v-b-tooltip.hover :title="$t('buttons.show')" @click="showModal(item['@id'])"></button>
            </div>
          </td>
        </tr>
        </tbody>
      </table>
      <div v-if="view">
         <pagination
           :view="view"
           @getPage="getItems($event)"
         ></pagination>
      </div>
    </div>
    <ShowRelationsModal
      @refetchRelations="fetchRelations()"
      v-if="relationIri !== null && canShowRelation"
      :showModal="isModalVisible"
      :iri="relationIri"
      @hideModal="hideModal"
    ></ShowRelationsModal>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import Loader from '@/components/Dashboard/Layout/Loader'
import Pagination from '@/components/Dashboard/Layout/Pagination'
import { checkPermission, getUserRoles } from '@/utils/checkRoles.js'
import ApiService from '@/utils/ApiService'
import getId from '@/utils/getIdFromLink'
import ShowRelationsModal from '@/components/Dashboard/Views/common/ShowRelationsModal'

export default {
  name: 'RelationsTable',
  components: {
    ShowRelationsModal,
    Loader,
    Pagination
  },
  computed: {
    ...mapGetters({
      created: 'excmrelation/create/created'
    }),
    canShowRelation () {
      return checkPermission('firms', 'EXCMRelationsShow')
    }
  },

  watch: {
    idUserData: {
      immediate: true,
      handler () {
        if ((this.idUserData || this.idUserData === null) || this.idCase || this.idFirm) {
          this.addToParams(this.idUserData, this.idCase, this.idFirm, this.searchParams)
          this.fetchRelations()
        }
      }
    },
    items: function () {
      if (this.items) {
        for (let i in this.items) {
          if (this.items[i].dateFrom) {
            this.items[i].dateFrom = this.$moment(this.items[i].dateFrom).format('YYYY-MM-DD HH:mm')
          }
        }
      }
    },
    created (val) {
      if (val) this.fetchRelations()
    }
  },
  props: {
    idFirm: {
      type: Number,
      required: false
    },
    idUserData: {
      required: false,
      default () {
        return getUserRoles().id_userdata
      }
    },
    idCase: {
      type: Number,
      required: false
    },
    contactType: {
      type: Number,
      required: true
    }
  },

  data () {
    return {
      isModalVisible: false,
      relationIri: null,
      items: [],
      isLoading: null,
      view: {},
      searchParams: {
        state: 1,
        contactType: this.contactType
      }
    }
  },
  created () {
    this.isLoading = true
  },

  methods: {
    getIdLink (link) {
      return getId(link)
    },
    fetchRelations () {
      this.getItems('e_x_c_m_relations', this.searchParams)
    },
    ...mapMutations({
      toggleMeetingModal: 'excmrelation/createModal/toggleMeetingModal',
      togglePhoneModal: 'excmrelation/createModal/togglePhoneModal'
    }),
    showCreateModal (val) {
      if (val === 2) {
        this.togglePhoneModal()
      }
      if (val === 1) {
        this.toggleMeetingModal()
      }
    },
    hideModal () {
      this.isModalVisible = false
      this.relationIri = null
    },
    showModal (iri) {
      this.relationIri = iri
      this.isModalVisible = !this.isModalVisible
    },
    addToParams (idUserData, idCase, idFirm, searchParams) {
      if (idUserData || idUserData === null) {
        searchParams['relationUserData.userData'] = idUserData
      }
      if (idCase) {
        searchParams.idCase = idCase
      }
      if (idFirm) {
        searchParams.userData = idFirm
      }
    },
    async getItems (route, params) {
      this.isLoading = true
      const response = await new ApiService(route, params).getResults()
      this.isLoading = false
      this.items = response.items
      this.view = response.view
    }
  }
}
</script>
